import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';

import { Color, Tile, TILE_TOKEN, TileId, TileType, TRANSLATION_NS } from '@contact/upgrade';

@NgModule({})
export class PortalForRootModule {
  constructor(@Optional() @SkipSelf() parentModule: PortalForRootModule) {
    if (parentModule) throw new Error(`[PortalForRootModule] module is already loaded`);
  }

  static instance(options: { path: string }): ModuleWithProviders<PortalForRootModule> {
    return {
      ngModule: PortalForRootModule,
      providers: [
        // portal declaration
        {
          provide: TILE_TOKEN,
          useValue: {
            id: TileId.PORTAL,
            type: TileType.STANDARD,
            icon: 'apps',
            color: Color.BLUE,
            platforms: {
              desktop: {
                path: options.path,
              },
            },
          } as Tile,
          multi: true,
        },

        {
          provide: TRANSLATION_NS,
          useValue: 'portal',
          multi: true,
        },
      ],
    };
  }
}
